import axios from "axios";
import { toastr } from "react-redux-toastr";
import { initialize } from "redux-form";

// STATES
const INITIAL_VALUES = { name: "", description: "" };
const INITIAL_STATE = {
  list: [],
  show: "list",
  errors: {},
};

// ACTIONS
export function getList() {
  const request = axios.get(`${process.env.REACT_APP_API_HOST}/crash_results`);
  return {
    type: "CRASH_RESULTS_FETCHED",
    payload: request,
  };
}

export function create(values, callback = null) {
  return submit(values, "post", callback);
}

function submit(values, method, callback) {
  return (dispatch) => {
    axios[method](`${process.env.REACT_APP_API_HOST}/crash_results`, values)
      .then((resp) => {
        if (callback) {
          dispatch(callback(resp.data.data.id));
        }
      })
      .catch((e) => {
        if (!e.response) {
          toastr.error("Erro", "Desconhecido :-/");
          console.log(e);
        } else if (!e.response.data) {
          toastr.error("Erro", e.response.message);
        } else if (e.response.data.errors) {
          Object.entries(e.response.data.errors).forEach(([key, error]) => toastr.error(key, error[0]));
        } else if (e.response.data) {
          toastr.error("Erro", e.response.data.message);
        }
      });
  };
}

export function showContent(flag) {
  return {
    type: "CRASH_RESULT_CONTENT_CHANGED",
    payload: flag,
  };
}

// export function showUpdate(crashResult) {
//     return [
//         showContent('form'),
//         initialize('crashResultForm', crashResult)
//     ]
// }

export function init() {
  return [initialize("crashResultForm", INITIAL_VALUES), showContent("list")];
}

// REDUCER
export function crashResultReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "CRASH_RESULTS_FETCHED":
      return { ...state, list: action.payload.data ? action.payload.data.data : [] };

    case "CRASH_RESULT_CONTENT_CHANGED":
      return { ...state, show: action.payload };

    default:
      return state;
  }
}
